import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Integration.UsBank.Info.IRequest;
type Response = Api.Core.Integration.UsBank.Info.IResponse;
type Headers = Api.Core.Integration.UsBank.Info.IHeaders;
const url = '/api/UsBank/Payment/Info/:usBankCardId';
export default async function usBankInfoApi(params?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url, params),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
